import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import { useCallback } from "react";
import { SingleGameActionType } from "../SingleGameReducer";
import { GameState } from "../Types";
import { KeyboardComponent } from "./KeyboardComponent";
import WordRowComponent from "./WordRowComponent";
export const DoubleGameComponent = ({ leftGame, dispatchLeftGameAction, rightGame, dispatchRightGameAction }) => {
    let key = 0;
    const leftWordRowComponents = leftGame.wordRows.map((wordRow) => {
        key = key + 1;
        return _jsx(WordRowComponent, { letterBoxes: wordRow.letterBoxes }, key);
    });
    const rightWordComponents = rightGame.wordRows.map((wordRow) => {
        key = key + 1;
        return _jsx(WordRowComponent, { letterBoxes: wordRow.letterBoxes }, key);
    });
    const keyboardListener = useCallback((keyCode) => {
        const dispatchers = [dispatchLeftGameAction, dispatchRightGameAction];
        dispatchers.forEach((dispatcher) => {
            if (keyCode === 'enter') {
                dispatcher({
                    type: SingleGameActionType.submitGuess
                });
            }
            else if (keyCode === 'backspace') {
                dispatcher({
                    type: SingleGameActionType.deleteLetter
                });
            }
            else {
                dispatcher({
                    type: SingleGameActionType.addLetter,
                    payload: {
                        letter: keyCode
                    }
                });
            }
        });
    }, [dispatchLeftGameAction, dispatchRightGameAction]);
    return (_jsxs(Stack, { direction: "column", sx: {
            alignItems: "center",
        }, children: [_jsxs(Stack, { direction: "row", spacing: "10px", sx: {
                    marginTop: "20px",
                }, children: [_jsx(Box, { children: leftWordRowComponents }), _jsx(Box, { children: rightWordComponents })] }), (leftGame.state === GameState.playing || rightGame.state === GameState.playing) ? _jsx(Box, { sx: {
                    marginTop: "20px",
                }, children: _jsx(KeyboardComponent, { keyboardListener: keyboardListener }) })
                : null] }));
};
